import axios from "axios";
import { MAIN_URL } from "../../Configs/Urls";
import toast from "react-hot-toast";

export async function fetchUserCurrentLocationData() {
  try {
    const response = await fetch("https://ipapi.co/json/");
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("the main error is  : ", error);
    throw error;
  }
}

export let verifyLoginTokenUser = async (token) => {
  try {
    // Send the token to the backend for verification
    let response = await axios.post(`${MAIN_URL}users/login/token`, { token });

    // Check if the response is successful
    if (response.status === 200 && response.data.user) {
      // Token is valid
      return [true, response.data.user];
    } else {
      // Token is invalid
      return [false, null];
    }
  } catch (error) {
    // Handle errors (e.g., token expired, network issues, etc.)
    console.error("Error verifying login token:", error);
    return [false, null];
  }
};

export let verifyLoginTokenAdmin = async (token) => {
  try {
    // Send the token to the backend for verification
    let response = await axios.post(`${MAIN_URL}admins/login-with-token`, {
      token,
    });

    // Check if the response is successful
    if (response.status === 200 && response.data.admin) {
      // Token is valid
      return [true, response.data.admin];
    } else {
      // Token is invalid
      return [false, null];
    }
  } catch (error) {
    // Handle errors (e.g., token expired, network issues, etc.)
    console.error("Error verifying login token:", error);
    return [false, null];
  }
};

export let isUserExist = async (requestData) => {
  try {
    let response = await axios.post(`${MAIN_URL}users/check-user`, requestData);
    console.log("response is : ", response);

    return { error: false, data: response.data.exists };
  } catch (error) {
    toast.error(`${error.message}`);
    console.error("Error checking user:", error);
    return { error: true, data: false };
  }
};

export let registerUser = async (requestData, url) => {
  try {
    let response = await axios.post(`${MAIN_URL}users${url}`, requestData);
    console.log("response is : ", response);

    if (response.status === 200) {
      toast.success(response?.data?.message, {
        style: {
          fontFamily: `var(--font-family-proxima_nova-semibold)`,
          borderRadius: "10px",
          background: "#333",
          color: "#fff",
        },

        duration: 4000,
      });
      return { error: false, data: response.data };
    }
  } catch (error) {
    toast.error(`${error?.response?.data?.message || error?.message}`, {
      style: {
        fontFamily: `var(--font-family-proxima_nova-semibold)`,
        borderRadius: "10px",
        background: "#333",
        color: "#fff",
      },
    });
    console.error("Error checking user:", error);
    return { error: true, data: null };
  }
};

export let VerifyOTP = async (requestData) => {
  try {
    let response = await axios.post(`${MAIN_URL}users/verify-otp`, requestData);
    console.log("response is : ", response);

    if (response.status === 200) {
      toast.success(response?.data?.message, {
        style: {
          fontFamily: `var(--font-family-proxima_nova-semibold)`,
          borderRadius: "10px",
          background: "#333",
          color: "#fff",
        },

        duration: 4000,
      });
      return { error: false, data: response.data };
    }
    return { error: false, data: response.data };
  } catch (error) {
    toast.error(`${error?.response?.data?.message || error?.message}`, {
      style: {
        fontFamily: `var(--font-family-proxima_nova-semibold)`,
        borderRadius: "10px",
        background: "#333",
        color: "#fff",
      },
    });
    console.error("Error checking user:", error);
    return { error: true, data: null };
  }
};

export let VerifyOTPV2 = async (requestData, id, token) => {
  try {
    let response = await axios.post(
      `${MAIN_URL}users/${id}/verify-otp`,
      requestData,
      {
        headers: {
          Authorization: `Bearer ${token}`, // Attach the token
        },
      }
    );
    console.log("response is : ", response);

    if (response.status === 200) {
      toast.success(response?.data?.message, {
        style: {
          fontFamily: `var(--font-family-proxima_nova-semibold)`,
          borderRadius: "10px",
          background: "#333",
          color: "#fff",
        },

        duration: 4000,
      });
      return { error: false, data: response.data };
    }
    return { error: false, data: response.data };
  } catch (error) {
    toast.error(`${error?.response?.data?.message || error?.message}`, {
      style: {
        fontFamily: `var(--font-family-proxima_nova-semibold)`,
        borderRadius: "10px",
        background: "#333",
        color: "#fff",
      },
    });
    console.error("Error checking user:", error);
    return { error: true, data: null };
  }
};

export let RegisterUserMain = async (requestData) => {
  try {
    let response = await axios.post(
      `${MAIN_URL}users/create-user`,
      requestData
    );
    console.log("response is : ", response);

    return { error: false, data: response.data };
  } catch (error) {
    toast.error(`${error?.response?.data?.message || error?.message}`, {
      style: {
        fontFamily: `var(--font-family-proxima_nova-semibold)`,
        borderRadius: "10px",
        background: "#333",
        color: "#fff",
      },
    });
    console.error("Error checking user:", error);
    return { error: true, data: null };
  }
};

export let LoginWithAuthenticator = async (requestData, showMsg) => {
  try {
    let response = await axios.post(
      `${MAIN_URL}users/login/authenticator`,
      requestData
    );
    console.log("response is : ", response);

    if (response.status === 200) {
      if (showMsg == true) {
        toast.success(response?.data?.message, {
          style: {
            fontFamily: `var(--font-family-proxima_nova-semibold)`,
            borderRadius: "10px",
            background: "#333",
            color: "#fff",
          },

          duration: 6000,
        });
      }
      return { error: false, data: response.data };
    }
    return { error: false, data: response.data };
  } catch (error) {
    toast.error(`${error?.response?.data?.message || error?.message}`, {
      style: {
        fontFamily: `var(--font-family-proxima_nova-semibold)`,
        borderRadius: "10px",
        background: "#333",
        color: "#fff",
      },
    });
    console.error("Error checking user:", error);
    return { error: true, data: null };
  }
};

export let LoginWithOtp = async (requestData) => {
  try {
    let response = await axios.post(`${MAIN_URL}users/login/otp`, requestData);
    console.log("response is : ", response);

    if (response.status === 200) {
      toast.success(response?.data?.message, {
        style: {
          fontFamily: `var(--font-family-proxima_nova-semibold)`,
          borderRadius: "10px",
          background: "#333",
          color: "#fff",
        },

        duration: 6000,
      });

      return { error: false, data: response.data };
    }
    return { error: false, data: response.data };
  } catch (error) {
    toast.error(`${error?.response?.data?.message || error?.message}`, {
      style: {
        fontFamily: `var(--font-family-proxima_nova-semibold)`,
        borderRadius: "10px",
        background: "#333",
        color: "#fff",
      },
    });
    console.error("Error checking user:", error);
    return { error: true, data: null };
  }
};

export let sendOtp = async (requestData, url) => {
  try {
    let response = await axios.post(`${MAIN_URL}users${url}`, requestData);
    console.log("response is : ", response);

    if (response.status === 200) {
      toast.success(response?.data?.message, {
        style: {
          fontFamily: `var(--font-family-proxima_nova-semibold)`,
          borderRadius: "10px",
          background: "#333",
          color: "#fff",
        },

        duration: 4000,
      });

      return { error: false, data: response.data };
    }
    return { error: false, data: response.data };
  } catch (error) {
    toast.error(`${error?.response?.data?.message || error?.message}`, {
      style: {
        fontFamily: `var(--font-family-proxima_nova-semibold)`,
        borderRadius: "10px",
        background: "#333",
        color: "#fff",
      },
    });
    console.error("Error checking user:", error);
    return { error: true, data: null };
  }
};

export let sendOtpV2 = async (requestData, url, token) => {
  try {
    let response = await axios.post(`${MAIN_URL}users${url}`, requestData, {
      headers: {
        Authorization: `Bearer ${token}`, // Attach the token
      },
    });
    console.log("response is : ", response);

    if (response.status === 200) {
      toast.success(response?.data?.message, {
        style: {
          fontFamily: `var(--font-family-proxima_nova-semibold)`,
          borderRadius: "10px",
          background: "#333",
          color: "#fff",
        },

        duration: 4000,
      });

      return { error: false, data: response.data };
    }
    return { error: false, data: response.data };
  } catch (error) {
    toast.error(`${error?.response?.data?.message || error?.message}`, {
      style: {
        fontFamily: `var(--font-family-proxima_nova-semibold)`,
        borderRadius: "10px",
        background: "#333",
        color: "#fff",
      },
    });
    console.error("Error checking user:", error);
    return { error: true, data: null };
  }
};

export let GetTravellers = async (url, token) => {
  try {
    let response = await axios.get(url ,{
      headers: {
        Authorization: `Bearer ${token}`, // Attach the token
      }
    });
    console.log("response is : ", response);

    if (response.status === 200) {
      return { error: false, data: response.data };
    }
    return { error: false, data: response.data };
  } catch (error) {
    toast.error(`${error?.response?.data?.message || error?.message}`, {
      style: {
        fontFamily: `var(--font-family-proxima_nova-semibold)`,
        borderRadius: "10px",
        background: "#333",
        color: "#fff",
      },
    });
    console.error("Error checking user:", error);
    return { error: true, data: null };
  }
};

export let AddTraveller = async (requestData, url, token) => {
  try {
    let response = await axios.post(url, requestData, {
      headers: {
        Authorization: `Bearer ${token}`, // Attach the token
      },
    });
    console.log("response is : ", response);

    if (response.status === 200) {
      toast.success(response?.data?.message, {
        style: {
          fontFamily: `var(--font-family-proxima_nova-semibold)`,
          borderRadius: "10px",
          background: "#333",
          color: "#fff",
        },

        duration: 4000,
      });

      return { error: false, data: response.data };
    }
    return { error: false, data: response.data };
  } catch (error) {
    toast.error(`${error?.response?.data?.message || error?.message}`, {
      style: {
        fontFamily: `var(--font-family-proxima_nova-semibold)`,
        borderRadius: "10px",
        background: "#333",
        color: "#fff",
      },
    });
    console.error("Error checking user:", error);
    return { error: true, data: null };
  }
};

export let UpdateTraveller = async (requestData, url, token) => {
  try {
    let response = await axios.put(url, requestData, {
      headers: {
        Authorization: `Bearer ${token}`, // Attach the token
      },
    });
    console.log("response is : ", response);

    if (response.status === 200) {
      toast.success(response?.data?.message, {
        style: {
          fontFamily: `var(--font-family-proxima_nova-semibold)`,
          borderRadius: "10px",
          background: "#333",
          color: "#fff",
        },

        duration: 4000,
      });

      return { error: false, data: response.data };
    }
    return { error: false, data: response.data };
  } catch (error) {
    toast.error(`${error?.response?.data?.message || error?.message}`, {
      style: {
        fontFamily: `var(--font-family-proxima_nova-semibold)`,
        borderRadius: "10px",
        background: "#333",
        color: "#fff",
      },
    });
    console.error("Error checking user:", error);
    return { error: true, data: null };
  }
};

export let RemoveTraveller = async (url, token) => {
  try {
    let response = await axios.delete(url, {
      headers: {
        Authorization: `Bearer ${token}`, // Attach the token
      },
    });
    console.log("response is : ", response);

    if (response.status === 200) {
      toast.success(response?.data?.message, {
        style: {
          fontFamily: `var(--font-family-proxima_nova-semibold)`,
          borderRadius: "10px",
          background: "#333",
          color: "#fff",
        },

        duration: 4000,
      });

      return { error: false, data: response.data };
    }
    return { error: false, data: response.data };
  } catch (error) {
    toast.error(`${error?.response?.data?.message || error?.message}`, {
      style: {
        fontFamily: `var(--font-family-proxima_nova-semibold)`,
        borderRadius: "10px",
        background: "#333",
        color: "#fff",
      },
    });
    console.error("Error checking user:", error);
    return { error: true, data: null };
  }
};

export let resetPassword = async (requestData, url) => {
  try {
    let response = await axios.post(`${MAIN_URL}users${url}`, requestData);
    console.log("response is : ", response);

    if (response.status === 200) {
      toast.success(response?.data?.message, {
        style: {
          fontFamily: `var(--font-family-proxima_nova-semibold)`,
          borderRadius: "10px",
          background: "#333",
          color: "#fff",
        },

        duration: 4000,
      });

      return { error: false, data: response.data };
    }
    return { error: false, data: response.data };
  } catch (error) {
    toast.error(`${error?.response?.data?.message || error?.message}`, {
      style: {
        fontFamily: `var(--font-family-proxima_nova-semibold)`,
        borderRadius: "10px",
        background: "#333",
        color: "#fff",
      },
    });
    console.error("Error checking user:", error);
    return { error: true, data: null };
  }
};

export let LoginTheAdmin = async (requestData) => {
  try {
    let response = await axios.post(`${MAIN_URL}admins/login-v4`, requestData);
    console.log("response is : ", response);

    if (response.status === 200) {
      toast.success(response?.data?.message, {
        style: {
          fontFamily: `var(--font-family-proxima_nova-semibold)`,
          borderRadius: "10px",
          background: "#333",
          color: "#fff",
        },

        duration: 4000,
      });

      return { error: false, data: response.data };
    }
    return { error: false, data: response.data };
  } catch (error) {
    toast.error(`${error?.response?.data?.message || error?.message}`, {
      style: {
        fontFamily: `var(--font-family-proxima_nova-semibold)`,
        borderRadius: "10px",
        background: "#333",
        color: "#fff",
      },
    });
    console.error("Error checking user:", error);
    return { error: true, data: null };
  }
};

export let UpdateUserGeneralData = async (requestData, user_id, token) => {
  try {
    let response = await axios.put(
      `${MAIN_URL}users/${user_id}/user-data/${requestData.id}`,
      requestData,
      {
        headers: {
          Authorization: `Bearer ${token}`, // Attach the token
        },
      }
    );

    console.log("response is : ", response);

    return { error: false, data: response.data };
  } catch (error) {
    toast.error(`${error?.response?.data?.message || error?.message}`, {
      style: {
        fontFamily: `var(--font-family-proxima_nova-semibold)`,
        borderRadius: "10px",
        background: "#333",
        color: "#fff",
      },
    });
    console.error("Error checking user:", error);
    return { error: true, data: null };
  }
};

export let UpdatePassword = async (password, user_id, token) => {
  try {
    let response = await axios.post(
      `${MAIN_URL}users/${user_id}/change-password`,
      { password, token },
      {
        headers: {
          Authorization: `Bearer ${token}`, // Attach the token
        },
      }
    );

    console.log("response is : ", response);

    return { error: false, data: response.data };
  } catch (error) {
    toast.error(`${error?.response?.data?.message || error?.message}`, {
      style: {
        fontFamily: `var(--font-family-proxima_nova-semibold)`,
        borderRadius: "10px",
        background: "#333",
        color: "#fff",
      },
    });
    console.error("Error checking user:", error);
    return { error: true, data: null };
  }
};

export let LogoutUser = async (url, token) => {
  try {
    const response = await axios.get(`${MAIN_URL}${url}`, {
      headers: {
        Authorization: `Bearer ${token}`, // Attach the token
      },
    });

    console.log("response is : ", response);

    if (response.status === 200) {
      toast.success(response?.data?.message, {
        style: {
          fontFamily: `var(--font-family-proxima_nova-semibold)`,
          borderRadius: "10px",
          background: "#333",
          color: "#fff",
        },
        duration: 4000,
      });

      return { error: false, data: response.data };
    }
    return { error: false, data: response.data };
  } catch (error) {
    toast.error(`${error?.response?.data?.message || error?.message}`, {
      style: {
        fontFamily: `var(--font-family-proxima_nova-semibold)`,
        borderRadius: "10px",
        background: "#333",
        color: "#fff",
      },
    });
    console.error("Error checking user:", error);
    return { error: true, data: null };
  }
};

export let getBookingById = async (id , token) => {
  try {
    const response = await axios.get(`${MAIN_URL}users/get-user-booking/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`, // Attach the token
      },
    });

    console.log("response is : ", response);

    return { error: false, data: response.data };

  } catch (error) {
    toast.error(`${error?.response?.data?.message || error?.message}`, {
      style: {
        fontFamily: `var(--font-family-proxima_nova-semibold)`,
        borderRadius: "10px",
        background: "#333",
        color: "#fff",
      },
    });
    console.error("Error checking user:", error);
    return { error: true, data: null };
  }
};

export let getBookingDetailed = async (id , token) => {
  try {
    const response = await axios.get(`${MAIN_URL}users/get-user-booking-detailed/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`, // Attach the token
      },
    });

    console.log("response is : ", response);

    return { error: false, data: response.data };

  } catch (error) {
    toast.error(`${error?.response?.data?.message || error?.message}`, {
      style: {
        fontFamily: `var(--font-family-proxima_nova-semibold)`,
        borderRadius: "10px",
        background: "#333",
        color: "#fff",
      },
    });
    console.error("Error checking user:", error);
    return { error: true, data: null };
  }
};

export let UpdateBookingStatus = async (id , token) => {
  try {
    const response = await axios.get(`${MAIN_URL}users/flights/update-failed-booking/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`, // Attach the token
      },
    });

    console.log("response is : ", response);

    return { error: false, data: response.data };

  } catch (error) {
    toast.error(`${error?.response?.data?.message || error?.message}`, {
      style: {
        fontFamily: `var(--font-family-proxima_nova-semibold)`,
        borderRadius: "10px",
        background: "#333",
        color: "#fff",
      },
    });
    console.error("Error checking user:", error);
    return { error: true, data: null };
  }
};
